export default __webpack_public_path__ + "static/media/ayush.13a3e769.png";